import { useCallback, useMemo, useState } from "react";
import { ALL_CHARTS_TAB_ID, ALL_CHARTS_TAB_LABEL } from "../constants";
import { getEnabledDashboardCharts } from "../chartRegistry";

export function useDashboardChartTabs() {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const charts = useMemo(() => getEnabledDashboardCharts(), []);

  const maxTabIndex = charts.length;
  const safeTabIndex = Math.min(Math.max(0, selectedTabIndex), maxTabIndex);
  const isAllChartsView = safeTabIndex === 0;

  const selectorTabs = useMemo(
    () => [{ id: ALL_CHARTS_TAB_ID, label: ALL_CHARTS_TAB_LABEL }, ...charts.map((c) => ({ id: c.id, label: c.title }))],
    [charts]
  );

  const goToChartTab = useCallback(
    (chartIndex) => {
      const next = Math.min(Math.max(1, chartIndex + 1), maxTabIndex);
      setSelectedTabIndex(next);
    },
    [maxTabIndex]
  );

  return {
    charts,
    selectedTabIndex,
    setSelectedTabIndex,
    safeTabIndex,
    isAllChartsView,
    selectorTabs,
    goToChartTab,
  };
}
